(function () {
  function initPhylumMegaNav() {
  const root = document.querySelector('[data-phylum-mega-nav]');
  if (!root) return;

  const hb = root.querySelector('#phylum-hamburger') || root.querySelector('#hamburger');
  const mobilePanelScroll = root.querySelector('#phylum-mobilePanelScroll') || root.querySelector('#mobilePanelScroll');
  const navBackdrop = root.querySelector('#phylum-navBackdrop') || root.querySelector('#navBackdrop');

  if (navBackdrop && navBackdrop.parentElement !== document.body) {
    document.body.appendChild(navBackdrop);
  }

  let menuCloseTimer;

  const closeMobileMenu = () => {
    document.body.classList.remove('menu-open');
    hb.setAttribute('aria-expanded', 'false');
    hb.setAttribute('aria-label', 'Open menu');
    clearTimeout(menuCloseTimer);
    menuCloseTimer = setTimeout(() => {
      mobilePanelScroll.querySelectorAll('.m-group.open').forEach((g) => {
        g.classList.remove('open');
        g.querySelector('.m-parent')?.setAttribute('aria-expanded', 'false');
      });
      mobilePanelScroll.querySelectorAll('.m-sub').forEach((sub) => {
        sub.style.maxHeight = '0px';
      });
      mobilePanelScroll.scrollTop = 0;
    }, 620);
  };

  const openMobileMenu = () => {
    clearTimeout(menuCloseTimer);
    document.body.classList.add('menu-open');
    hb.setAttribute('aria-expanded', 'true');
    hb.setAttribute('aria-label', 'Close menu');
    mobilePanelScroll.scrollTop = 0;
  };

  if (hb && mobilePanelScroll) {
    hb.addEventListener('click', () => {
      document.body.classList.contains('menu-open') ? closeMobileMenu() : openMobileMenu();
    });
  }

  const items = root.querySelectorAll('.nav-item[data-menu]');
  let closeTimer;
  let navPaintTimer;
  const GUTTER = 24;

  const releaseNavChrome = () => {
    document.body.classList.remove('nav-open');
    document.body.classList.add('nav-closing');
    clearTimeout(navPaintTimer);
    navPaintTimer = setTimeout(() => {
      document.body.classList.remove('nav-closing');
    }, 520);
  };

  const holdNavChrome = () => {
    clearTimeout(navPaintTimer);
    document.body.classList.remove('nav-closing');
    document.body.classList.add('nav-open');
  };

  function positionMenu(item) {
    const mega = item.querySelector('.mega');
    if (!mega) return;
    mega.style.left = '0px';
    const itemLeft = item.getBoundingClientRect().left;
    const w = mega.offsetWidth;
    let centeredLeft = (window.innerWidth - w) / 2;
    centeredLeft = Math.max(GUTTER, Math.min(centeredLeft, window.innerWidth - w - GUTTER));
    mega.style.left = centeredLeft - itemLeft + 'px';
  }

  items.forEach((item) => {
    const btn = item.querySelector('.nav-link');
    const mega = item.querySelector('.mega');
    if (!btn) return;

    const open = () => {
      clearTimeout(closeTimer);
      const switching = [...items].some((i) => i !== item && i.classList.contains('open'));
      if (switching) root.classList.add('is-menu-switch');
      items.forEach((i) => {
        if (i !== item && i.hasAttribute('data-menswear')) {
          resetMenswearWaitlist(i);
        }
        i.classList.remove('open');
        const b = i.querySelector('.nav-link');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      positionMenu(item);
      holdNavChrome();
      if (switching) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => root.classList.remove('is-menu-switch'));
        });
      }
      if (item.hasAttribute('data-menswear')) {
        window.requestAnimationFrame(() => prepareKlaviyoWaitlist(item));
      }
    };

    const scheduleClose = () => {
      closeTimer = setTimeout(() => {
        if (item.hasAttribute('data-menswear')) {
          resetMenswearWaitlist(item);
        }
        item.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        if (!root.querySelector('.nav-item.open')) {
          releaseNavChrome();
        }
      }, 220);
    };

    const cancelClose = () => clearTimeout(closeTimer);

    const pointerStillInside = (event, el) => {
      if (!el || !event) return false;
      const next = event.relatedTarget;
      if (next && el.contains(next)) return true;
      const rect = el.getBoundingClientRect();
      return event.clientX >= rect.left && event.clientX <= rect.right
        && event.clientY >= rect.top && event.clientY <= rect.bottom;
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', (e) => {
      if (pointerStillInside(e, mega) || pointerStillInside(e, item)) return;
      scheduleClose();
    });
    if (mega) {
      mega.addEventListener('mouseenter', cancelClose);
      mega.addEventListener('mouseleave', (e) => {
        if (pointerStillInside(e, item) || pointerStillInside(e, mega)) return;
        scheduleClose();
      });
    }
    btn.addEventListener('focus', open);
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      item.classList.contains('open') ? scheduleClose() : open();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    items.forEach((i) => {
      if (i.hasAttribute('data-menswear')) {
        resetMenswearWaitlist(i);
      }
      i.classList.remove('open');
      i.querySelector('.nav-link')?.setAttribute('aria-expanded', 'false');
    });
    releaseNavChrome();
    if (document.body.classList.contains('menu-open') && hb && mobilePanelScroll) closeMobileMenu();
  });

  const versionSwitcher = document.querySelector('.nav-version-switcher');
  const versionButtons = versionSwitcher ? versionSwitcher.querySelectorAll('[data-nav-version]') : [];

  const getNavVersion = () =>
    document.documentElement.getAttribute('data-nav-version') || root.dataset.navVersion || 'promo';

  const getMegaContent = (item) => {
    const version = getNavVersion();
    if (item.hasAttribute('data-menswear')) {
      return item.querySelector('.nav-version-' + version) || item.querySelector('.mega-inner');
    }
    return item.querySelector('.nav-version-current') || item.querySelector('.mega-inner');
  };

  const buildMobilePromoFromDesktop = (megaContent) => {
    const wrap = document.createElement('div');
    wrap.className = 'm-promo';

    const visualSrc = megaContent.querySelector('.mega-promo-visual');
    if (visualSrc) {
      const visual = document.createElement('div');
      visual.className = 'm-promo-visual';
      const img = visualSrc.querySelector('.feature-img');
      if (img) visual.appendChild(img.cloneNode(true));
      wrap.appendChild(visual);
    }

    const contentSrc = megaContent.querySelector('.mega-promo-content');
    if (contentSrc) {
      const body = contentSrc.cloneNode(true);
      body.classList.remove('mega-promo-content');
      body.classList.add('m-promo-body');
      wrap.appendChild(body);
    }

    return wrap;
  };

  const KLAVIYO_WAITLIST_FORM_ID = 'T43KxT';
  const KLAVIYO_WAITLIST_LIST_ID = 'TpYx3C';
  const KLAVIYO_COMPANY_ID = 'WhDwC2';
  const WAITLIST_LOADING_MIN_MS = 1600;

  const isKlaviyoWaitlistFormEvent = (detail) => {
    if (!detail) return false;
    const formId = String(detail.formId || detail.formVersionId || '');
    return formId === KLAVIYO_WAITLIST_FORM_ID || formId.includes(KLAVIYO_WAITLIST_FORM_ID);
  };

  const isWaitlistLocked = (wrap) =>
    !!wrap &&
    (wrap.classList.contains('is-success') ||
      wrap.classList.contains('is-submitting') ||
      wrap.classList.contains('is-loading'));

  const resetWaitlistWrap = (wrap) => {
    if (!wrap) return;
    wrap.classList.remove('is-success', 'is-success-klaviyo', 'is-submitting', 'is-loading', 'is-fallback-active');
    clearWaitlistSubmitError(wrap);

    wrap.querySelectorAll('input[type="email"]').forEach((input) => {
      setEmailInputValue(input, '');
    });

    wrap.querySelectorAll('.waitlist-form-fallback, .waitlist-embed, .klaviyo-form-T43KxT').forEach((el) => {
      el.removeAttribute('hidden');
      el.style.removeProperty('display');
    });

    const embed = wrap.querySelector('.waitlist-embed');
    if (embed) {
      embed.classList.remove('waitlist-embed-sr-only');
    }

    const nativeForm = wrap.querySelector('.waitlist-form-fallback');
    if (nativeForm) nativeForm.hidden = true;

    const status = wrap.querySelector('.waitlist-klaviyo-success');
    if (status) {
      if (status.dataset.successText) {
        status.textContent = status.dataset.successText;
      }
      status.hidden = true;
      status.style.removeProperty('display');
    }

    reseedKlaviyoPlaceholder(wrap);
  };

  const resetMenswearWaitlist = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('.waitlist-wrap.waitlist-klaviyo').forEach((wrap) => {
      if (wrap.classList.contains('is-submitting')) return;
      resetWaitlistWrap(wrap);
    });
  };

  const resetKlaviyoWaitlistUi = (wrap) => {
    if (!wrap || isWaitlistLocked(wrap)) return;
    resetWaitlistWrap(wrap);
  };

  const isWaitlistFieldVisible = (el) => {
    if (!el) return false;
    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 8 && rect.height > 8;
  };

  const hasVisibleKlaviyoWaitlist = (wrap) => {
    if (!wrap) return false;
    const email = wrap.querySelector('.klaviyo-form-T43KxT input[type="email"]');
    const cta = wrap.querySelector(
      '.klaviyo-form-T43KxT button, .klaviyo-form-T43KxT a.needsclick, .klaviyo-form-T43KxT input[type="submit"]'
    );
    return isWaitlistFieldVisible(email) && isWaitlistFieldVisible(cta);
  };

  const reseedKlaviyoPlaceholder = (wrap) => {
    const embed = wrap.querySelector('.waitlist-embed');
    if (!embed) return;
    embed.innerHTML = '<div class="klaviyo-form-T43KxT"></div>';
  };

  const syncWaitlistFormVisibility = (scope = root) => {
    if (!scope) return;
    scope.querySelectorAll('.waitlist-wrap.waitlist-klaviyo').forEach((wrap) => {
      if (isWaitlistLocked(wrap)) return;
      const nativeForm = wrap.querySelector('.waitlist-form-fallback');
      const embed = wrap.querySelector('.waitlist-embed');
      if (!nativeForm) return;

      wrap.classList.add('is-fallback-active');
      nativeForm.hidden = false;
      if (embed) {
        embed.classList.add('waitlist-embed-sr-only');
        embed.style.removeProperty('display');
      }
    });
  };

  const waitForKlaviyoSubmit = (timeoutMs = 5000) =>
    new Promise((resolve) => {
      const timer = setTimeout(() => {
        window.removeEventListener('klaviyoForms', handler);
        resolve(false);
      }, timeoutMs);

      const handler = (event) => {
        const detail = event.detail || {};
        if (!isKlaviyoWaitlistFormEvent(detail)) return;
        if (detail.type !== 'submit' && detail.type !== 'stepSubmit') return;
        clearTimeout(timer);
        window.removeEventListener('klaviyoForms', handler);
        resolve(true);
      };

      window.addEventListener('klaviyoForms', handler);
    });

  const setEmailInputValue = (input, email) => {
    if (!input) return;
    const valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
    if (valueSetter) {
      valueSetter.call(input, email);
    } else {
      input.value = email;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const getKlaviyoExchangeId = () => {
    try {
      const match = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!match) return '';
      const decoded = JSON.parse(atob(decodeURIComponent(match[1].trim())));
      return decoded.$exchange_id || decoded._kx || '';
    } catch {
      return '';
    }
  };

  const identifyKlaviyoWaitlistProfile = (email) => {
    try {
      if (!email) return;
      const kl = window.klaviyo;
      if (kl && typeof kl.identify === 'function') {
        kl.identify({ email });
        return;
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['identify', { email }]);
    } catch {
      // Never block waitlist UX if onsite identify is unavailable.
    }
  };

  const subscribeEmailViaKlaviyoClient = async (email) => {
    try {
      const profileAttributes = {
        email,
        subscriptions: {
          email: {
            marketing: {
              consent: 'SUBSCRIBED',
            },
          },
        },
      };
      const exchangeId = getKlaviyoExchangeId();
      if (exchangeId) {
        profileAttributes._kx = exchangeId;
      }

      const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2026-07-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'PHYLUM Menswear Mega Menu',
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttributes,
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: KLAVIYO_WAITLIST_LIST_ID,
                },
              },
            },
          },
        }),
      });
      if (res.status === 202 || res.status === 409) return true;
      return false;
    } catch {
      return false;
    }
  };

  const clickKlaviyoWaitlistSubmit = (wrap, email) => {
    const klEmail = wrap.querySelector('.klaviyo-form-T43KxT input[type="email"]');
    const klSubmit = wrap.querySelector(
      '.klaviyo-form-T43KxT button, .klaviyo-form-T43KxT a.needsclick, .klaviyo-form-T43KxT input[type="submit"]'
    );
    if (!klEmail || !klSubmit) return false;

    klEmail.focus();
    setEmailInputValue(klEmail, email);
    klSubmit.click();
    return true;
  };

  const ensureKlaviyoEmbedReady = async (wrap, maxAttempts = 12) => {
    let embed = wrap.querySelector('.waitlist-embed');
    if (!embed) return false;

    embed.classList.remove('waitlist-embed-sr-only');
    embed.removeAttribute('hidden');
    embed.style.removeProperty('display');

    if (!embed.querySelector('.klaviyo-form-T43KxT')) {
      reseedKlaviyoPlaceholder(wrap);
    }

    initKlaviyoWaitlistEmbed(root);

    for (let i = 0; i < maxAttempts; i += 1) {
      if (wrap.querySelector('.klaviyo-form-T43KxT input[type="email"]')) return true;
      await new Promise((resolve) => setTimeout(resolve, 200));
    }

    return !!wrap.querySelector('.klaviyo-form-T43KxT input[type="email"]');
  };

  const hideWaitlistInputs = (wrap) => {
    wrap.querySelectorAll('.waitlist-form-fallback, .waitlist-embed, .klaviyo-form-T43KxT').forEach((el) => {
      el.setAttribute('hidden', '');
      el.style.setProperty('display', 'none', 'important');
    });
  };

  const showWaitlistStatus = (wrap) => {
    const status = wrap.querySelector('.waitlist-klaviyo-success');
    if (!status) return null;
    status.removeAttribute('hidden');
    status.style.setProperty('display', 'flex', 'important');
    return status;
  };

  const submitWaitlistViaEmbed = async (wrap, email) => {
    if (!wrap.querySelector('.klaviyo-form-T43KxT input[type="email"]')) {
      const ready = await ensureKlaviyoEmbedReady(wrap, 10);
      if (!ready) return false;
    }

    const submitPromise = waitForKlaviyoSubmit(5000);
    if (!clickKlaviyoWaitlistSubmit(wrap, email)) return false;
    return submitPromise;
  };

  const submitWaitlistToKlaviyo = async (wrap, email) => subscribeEmailViaKlaviyoClient(email);

  const waitForWaitlistMinimumDelay = async (submitStartedAt) => {
    const elapsed = performance.now() - submitStartedAt;
    const remaining = WAITLIST_LOADING_MIN_MS - elapsed;
    if (remaining > 0) {
      await new Promise((resolve) => setTimeout(resolve, remaining));
    }
  };

  const initKlaviyoWaitlistEmbed = (scope = root) => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['embedForm', KLAVIYO_WAITLIST_FORM_ID]);
    if (window.klaviyo && typeof window.klaviyo.loadForms === 'function') {
      window.klaviyo.loadForms();
    }
    scheduleKlaviyoLayoutFix(scope);
  };

  const prepareKlaviyoWaitlist = (scope = root) => {
    if (!scope) return;
    const wraps = scope.querySelectorAll('.waitlist-wrap.waitlist-klaviyo');
    let needsEmbed = false;
    wraps.forEach((wrap) => {
      if (wrap.classList.contains('is-submitting')) return;
      if (wrap.classList.contains('is-success')) return;
      resetKlaviyoWaitlistUi(wrap);
      needsEmbed = true;
    });
    if (!needsEmbed) return;
    initKlaviyoWaitlistEmbed(scope);
    syncWaitlistFormVisibility(scope);
    [250, 900, 1800].forEach((ms) => {
      setTimeout(() => syncWaitlistFormVisibility(scope), ms);
    });
  };

  const clearWaitlistSubmitError = (wrap) => {
    wrap?.querySelector('.waitlist-submit-error')?.remove();
  };

  const showWaitlistSubmitError = (wrap, message) => {
    if (!wrap) return;
    clearWaitlistSubmitError(wrap);
    const error = document.createElement('p');
    error.className = 'waitlist-submit-error';
    error.setAttribute('role', 'alert');
    error.textContent = message;
    const anchor = wrap.querySelector('.waitlist-form-fallback:not([hidden])') || wrap.querySelector('.waitlist-embed');
    if (anchor) {
      anchor.insertAdjacentElement('afterend', error);
    } else {
      wrap.appendChild(error);
    }
  };

  const markWaitlistPending = (wrap) => {
    if (!wrap || wrap.classList.contains('is-success') || wrap.classList.contains('is-submitting')) return;
    clearWaitlistSubmitError(wrap);

    const status = wrap.querySelector('.waitlist-klaviyo-success');
    if (status) {
      if (!status.dataset.successText) {
        status.dataset.successText = status.textContent.trim();
      }
      status.hidden = true;
      status.style.setProperty('display', 'none', 'important');
    }

    wrap.classList.remove('is-success', 'is-success-klaviyo', 'is-loading');
    wrap.classList.add('is-submitting', 'is-fallback-active');
  };

  const showWaitlistLoading = (wrap) => {
    if (!wrap) return;
    wrap.classList.add('is-loading');

    const status = wrap.querySelector('.waitlist-klaviyo-success');
    if (status) {
      status.textContent = 'Adding you to the list…';
      status.removeAttribute('hidden');
      status.style.setProperty('display', 'flex', 'important');
    }
  };

  const clearWaitlistSubmitting = (wrap) => {
    if (!wrap || wrap.classList.contains('is-success')) return;
    wrap.classList.remove('is-submitting', 'is-loading');

    const status = wrap.querySelector('.waitlist-klaviyo-success');
    if (status) {
      if (status.dataset.successText) {
        status.textContent = status.dataset.successText;
      }
      status.hidden = true;
      status.style.removeProperty('display');
    }

    wrap.querySelectorAll('.waitlist-form-fallback, .waitlist-embed, .klaviyo-form-T43KxT').forEach((el) => {
      el.removeAttribute('hidden');
      el.style.removeProperty('display');
    });

    syncWaitlistFormVisibility(wrap.closest('[data-phylum-mega-nav]') || root);
  };

  const markWaitlistSuccess = (wrap) => {
    if (!wrap) return;
    wrap.classList.remove('is-fallback-active', 'is-success-klaviyo', 'is-submitting', 'is-loading');
    wrap.classList.add('is-success');
    clearWaitlistSubmitError(wrap);

    wrap.querySelectorAll('input[type="email"]').forEach((input) => {
      setEmailInputValue(input, '');
    });

    hideWaitlistInputs(wrap);

    wrap.querySelectorAll('.waitlist-form-fallback button, .klaviyo-form-T43KxT button, .klaviyo-form-T43KxT a.needsclick').forEach((btn) => {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    });

    const status = showWaitlistStatus(wrap);
    if (status && status.dataset.successText) {
      status.textContent = status.dataset.successText;
    }
  };

  const bindWaitlistForms = (scope) => {
    scope.querySelectorAll('.waitlist-form').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      if (form.getAttribute('action') !== '#') return;

      const submitBtn = form.querySelector('button[type="submit"]');

      form.addEventListener(
        'submit',
        async (e) => {
          e.preventDefault();
          e.stopPropagation();
          const wrap = form.closest('.waitlist-wrap');
          if (!wrap || wrap.classList.contains('is-success') || wrap.classList.contains('is-submitting')) return;

          const emailInput = form.querySelector('input[type="email"]');
          const email = (emailInput?.value || '').trim();
          if (!email) return;

          const submitStartedAt = performance.now();

          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.setAttribute('aria-busy', 'true');
          }

          markWaitlistPending(wrap);
          showWaitlistLoading(wrap);

          let submitted = false;
          try {
            submitted = await submitWaitlistToKlaviyo(wrap, email);
          } catch {
            submitted = false;
          } finally {
            await waitForWaitlistMinimumDelay(submitStartedAt);
            if (!wrap.classList.contains('is-success') && submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          }

          if (!submitted) {
            clearWaitlistSubmitting(wrap);
            showWaitlistSubmitError(
              wrap,
              'Something went wrong. Please try again in a moment.'
            );
            return;
          }

          markWaitlistSuccess(wrap);
          window.setTimeout(() => identifyKlaviyoWaitlistProfile(email), 0);
        },
        true
      );
    });
  };

  const bindKlaviyoWaitlistSuccess = () => {
    window.addEventListener('klaviyoForms', (event) => {
      const detail = event.detail || {};
      if (!isKlaviyoWaitlistFormEvent(detail)) return;

      root.querySelectorAll('.waitlist-wrap.waitlist-klaviyo').forEach((wrap) => {
        wrap.querySelectorAll(
          '.klaviyo-form-T43KxT [class*="success"], .klaviyo-form-T43KxT [data-testid*="success"], .klaviyo-form-T43KxT [aria-live="polite"]'
        ).forEach((el) => {
          el.style.setProperty('display', 'none', 'important');
        });
      });

      if (detail.type !== 'submit' && detail.type !== 'stepSubmit' && detail.type !== 'success') return;
      if (detail.type === 'success' && !root.querySelector('.waitlist-wrap.waitlist-klaviyo.is-submitting')) {
        root.querySelectorAll('.waitlist-wrap.waitlist-klaviyo:not(.is-success)').forEach((wrap) => {
          wrap.querySelectorAll('.klaviyo-form-T43KxT form').forEach((form) => {
            form.reset();
          });
        });
      }
    });
  };

  const ensureWaitlistSpacer = (wrap) => {
    if (!wrap.querySelector('.waitlist-foot-spacer')) {
      const spacer = document.createElement('div');
      spacer.className = 'waitlist-foot-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      wrap.appendChild(spacer);
    }
  };

  const fixKlaviyoWaitlistLayout = (scope = root) => {
    if (!scope) return;
    scope.querySelectorAll('.waitlist-wrap.waitlist-klaviyo').forEach((wrap) => {
      if (isWaitlistLocked(wrap)) return;
      ensureWaitlistSpacer(wrap);

      const embed = wrap.querySelector('.waitlist-embed');
      const embedHidden = !!(embed && embed.classList.contains('waitlist-embed-sr-only'));

      wrap.querySelectorAll('.klaviyo-form-T43KxT form').forEach((form) => {
        if (embedHidden && embed.contains(form)) return;
        form.style.setProperty('display', 'flex', 'important');
        form.style.setProperty('flex-direction', 'column', 'important');
        form.style.setProperty('align-items', 'stretch', 'important');
        form.style.setProperty('width', '100%', 'important');
      });

      wrap.querySelectorAll('.waitlist-embed, .klaviyo-form-T43KxT, .klaviyo-form-T43KxT form, .klaviyo-form-T43KxT form > div, .klaviyo-form-T43KxT > div').forEach((el) => {
        if (embedHidden && (el === embed || embed.contains(el))) return;
        el.style.setProperty('position', 'relative', 'important');
        el.style.setProperty('top', 'auto', 'important');
        el.style.setProperty('bottom', 'auto', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('max-height', 'none', 'important');
        el.style.setProperty('flex-grow', '0', 'important');
        el.style.setProperty('flex', '0 0 auto', 'important');
      });

      /* Klaviyo's embed keeps a reserved min-height (about 200–450px). While the fallback form is what's on screen, that shell has to leave the layout or the olive card stretches under the button. */
      if (embedHidden) {
        embed.style.setProperty('position', 'absolute', 'important');
        embed.style.setProperty('width', '1px', 'important');
        embed.style.setProperty('height', '1px', 'important');
        embed.style.setProperty('min-height', '0', 'important');
        embed.style.setProperty('max-height', '1px', 'important');
        embed.style.setProperty('overflow', 'hidden', 'important');
        embed.style.setProperty('clip-path', 'inset(50%)', 'important');
        embed.style.setProperty('margin', '0', 'important');
        embed.style.setProperty('pointer-events', 'none', 'important');
      }

      wrap.querySelectorAll('input[type="email"], input[type="text"]').forEach((input) => {
        input.style.setProperty('height', '44px', 'important');
        input.style.setProperty('min-height', '0', 'important');
        input.style.setProperty('max-height', '44px', 'important');
        input.style.setProperty('padding', '0 16px', 'important');
        input.style.setProperty('line-height', 'normal', 'important');
        input.style.setProperty('box-sizing', 'border-box', 'important');
      });

      wrap.querySelectorAll('button, a.needsclick, a[role="button"]').forEach((cta) => {
        cta.style.setProperty('position', 'relative', 'important');
        cta.style.setProperty('top', 'auto', 'important');
        cta.style.setProperty('bottom', 'auto', 'important');
        cta.style.setProperty('transform', 'none', 'important');
        cta.style.setProperty('margin-top', '5px', 'important');
        cta.style.setProperty('margin-bottom', '0', 'important');
        cta.style.setProperty('margin-left', '0', 'important');
        cta.style.setProperty('margin-right', '0', 'important');
      });
    });
  };

  let klaviyoLayoutTimer;
  const scheduleKlaviyoLayoutFix = (scope = root) => {
    clearTimeout(klaviyoLayoutTimer);
    klaviyoLayoutTimer = setTimeout(() => {
      fixKlaviyoWaitlistLayout(scope);
      syncWaitlistFormVisibility(scope);
      refreshOpenMobileSubHeights(scope === root ? mobilePanelScroll : scope);
    }, 50);
  };

  const refreshKlaviyoForms = (scope) => {
    if (!scope) return;
    prepareKlaviyoWaitlist(scope);
  };

  const observeKlaviyoWaitlist = () => {
    bindKlaviyoWaitlistSuccess();
    root.querySelectorAll('.waitlist-wrap.waitlist-klaviyo').forEach(resetKlaviyoWaitlistUi);
    root.querySelectorAll('.waitlist-wrap.waitlist-klaviyo').forEach((wrap) => {
      const observer = new MutationObserver(() => scheduleKlaviyoLayoutFix(root));
      observer.observe(wrap, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    });
    document.addEventListener('klaviyoForms', () => scheduleKlaviyoLayoutFix(root));
    window.addEventListener('load', () => {
      root.querySelectorAll('.waitlist-wrap.waitlist-klaviyo').forEach((wrap) => {
        if (!isWaitlistLocked(wrap)) {
          resetKlaviyoWaitlistUi(wrap);
        }
      });
      scheduleKlaviyoLayoutFix(root);
    });
    [500, 1500, 3000].forEach((ms) => setTimeout(() => scheduleKlaviyoLayoutFix(root), ms));
  };

  const collapseMobileSub = (sub) => {
    if (!sub) return;
    sub.style.maxHeight = `${sub.scrollHeight}px`;
    requestAnimationFrame(() => {
      sub.style.maxHeight = '0px';
    });
  };

  const expandMobileSub = (sub) => {
    if (!sub) return;
    sub.style.maxHeight = `${sub.scrollHeight}px`;
    const onEnd = (event) => {
      if (event.propertyName !== 'max-height') return;
      if (sub.closest('.m-group')?.classList.contains('open')) {
        sub.style.maxHeight = 'none';
      }
      sub.removeEventListener('transitionend', onEnd);
    };
    sub.addEventListener('transitionend', onEnd);
  };

  const closeMobileGroup = (group, immediate) => {
    if (!group) return;
    group.classList.remove('open');
    group.querySelector('.m-parent')?.setAttribute('aria-expanded', 'false');
    const sub = group.querySelector('.m-sub');
    if (!sub) return;
    if (!immediate) {
      collapseMobileSub(sub);
      return;
    }
    sub.style.transition = 'none';
    sub.style.maxHeight = '0px';
    sub.offsetHeight;
    sub.style.transition = '';
  };

  const scrollMobileGroupIntoView = (group) => {
    if (!mobilePanelScroll || !group) return;
    const scroller = mobilePanelScroll;
    const top = group.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
    scroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  const toggleMobileGroup = (group) => {
    if (!group) return;
    const isOpen = group.classList.contains('open');
    mobilePanelScroll.querySelectorAll('.m-group.open').forEach((g) => {
      if (g !== group) closeMobileGroup(g, !isOpen);
    });

    const sub = group.querySelector('.m-sub');
    const parent = group.querySelector('.m-parent');
    if (isOpen) {
      closeMobileGroup(group);
      return;
    }

    group.classList.add('open');
    parent?.setAttribute('aria-expanded', 'true');
    if (sub) sub.style.maxHeight = '0px';
    requestAnimationFrame(() => {
      scrollMobileGroupIntoView(group);
      if (sub) expandMobileSub(sub);
    });
  };

  const refreshOpenMobileSubHeights = (scope = mobilePanelScroll) => {
    if (!scope) return;
    scope.querySelectorAll('.m-group.open .m-sub').forEach((sub) => {
      sub.style.maxHeight = `${sub.scrollHeight}px`;
    });
  };

  const buildMobileMenu = () => {
    if (!mobilePanelScroll) return;
    mobilePanelScroll.innerHTML = '';
    items.forEach((item) => {
      const labelEl = item.querySelector('.nav-link-text');
      const label = labelEl
        ? labelEl.textContent
        : item.querySelector('.nav-link')?.textContent.trim() || '';

      const megaContent = getMegaContent(item);
      const group = document.createElement('div');
      group.className = 'm-group';

      const parent = document.createElement('button');
      parent.type = 'button';
      parent.className = 'm-parent';

      const showSoon = getNavVersion() === 'promo' && item.hasAttribute('data-menswear');
      const badge = item.querySelector('.nav-soon-badge');
      const badgeClone = showSoon && badge ? badge.cloneNode(true) : null;

      const labelWrap = document.createElement('span');
      labelWrap.className = 'm-parent-label';
      const labelSpan = document.createElement('span');
      labelSpan.textContent = label;
      labelWrap.appendChild(labelSpan);
      if (badgeClone) {
        badgeClone.classList.add('m-soon-badge');
        labelWrap.appendChild(badgeClone);
      }

      const toggle = document.createElement('span');
      toggle.className = 'm-toggle';
      toggle.setAttribute('aria-hidden', 'true');
      toggle.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
      parent.appendChild(labelWrap);
      parent.appendChild(toggle);
      group.appendChild(parent);

      const sub = document.createElement('div');
      sub.className = 'm-sub';

      if (megaContent && megaContent.classList.contains('mega-promo')) {
        sub.appendChild(buildMobilePromoFromDesktop(megaContent));
      } else {
        const inner = document.createElement('div');
        inner.className = 'm-sub-inner';
        (megaContent ? megaContent.querySelectorAll('.mega-col') : []).forEach((col) => {
          const cl = col.querySelector('.col-label');
          if (cl) {
            const l = document.createElement('span');
            l.className = 'm-sub-label';
            l.textContent = cl.textContent;
            inner.appendChild(l);
          }
          col.querySelectorAll('.col-list a').forEach((a) => {
            const link = document.createElement('a');
            link.href = a.getAttribute('href') || '#';
            link.textContent = a.textContent;
            inner.appendChild(link);
          });
        });
        sub.appendChild(inner);

        const feature = megaContent ? megaContent.querySelector('.mega-feature') : null;
        if (feature) {
          const featClone = feature.cloneNode(true);
          featClone.classList.add('m-feature');
          sub.appendChild(featClone);
        }
      }

      group.appendChild(sub);
      parent.setAttribute('aria-expanded', 'false');
      parent.addEventListener('click', () => toggleMobileGroup(group));
      mobilePanelScroll.appendChild(group);
    });

    mobilePanelScroll.querySelectorAll('.m-sub').forEach((sub) => {
      sub.style.maxHeight = '0px';
    });

    bindWaitlistForms(mobilePanelScroll);
    refreshKlaviyoForms(mobilePanelScroll);
    scheduleKlaviyoLayoutFix(mobilePanelScroll);
  };

  const applyNavVersion = (version) => {
    document.documentElement.setAttribute('data-nav-version', version);
    versionButtons.forEach((btn) => {
      const active = btn.dataset.navVersion === version;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    items.forEach((i) => {
      i.classList.remove('open');
      i.querySelector('.nav-link')?.setAttribute('aria-expanded', 'false');
    });
    releaseNavChrome();
    buildMobileMenu();
  };

  const savedVersion = sessionStorage.getItem('navVersion');
  if (versionSwitcher && (savedVersion === 'promo' || savedVersion === 'current')) {
    applyNavVersion(savedVersion);
  } else if (versionSwitcher) {
    applyNavVersion('current');
  } else {
    applyNavVersion(root.dataset.navVersion || 'promo');
  }

  versionButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const version = btn.dataset.navVersion;
      sessionStorage.setItem('navVersion', version);
      applyNavVersion(version);
    });
  });

  bindWaitlistForms(root);
  observeKlaviyoWaitlist();

  navBackdrop?.addEventListener('click', () => {
    items.forEach((i) => {
      if (i.hasAttribute('data-menswear')) {
        resetMenswearWaitlist(i);
      }
      i.classList.remove('open');
      i.querySelector('.nav-link')?.setAttribute('aria-expanded', 'false');
    });
    releaseNavChrome();
  });

  const headerEl = root.querySelector('.header');
  if (headerEl) {
    const scrollY = () => window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    let lastScrollY = scrollY();
    let scrollTick = false;

    const measureHeader = () => {
      const h = headerEl.offsetHeight;
      if (!h) return;
      const value = h + 'px';
      headerEl.style.setProperty('--phylum-header-h', value);
      document.documentElement.style.setProperty('--phylum-header-h', value);
    };
    measureHeader();

    const showHeader = () => headerEl.classList.remove('is-header-hidden');
    const mobileNav = window.matchMedia('(max-width: 1200px)');

    const syncHeaderVisibility = () => {
      const y = scrollY();
      const delta = y - lastScrollY;
      const menuLocked = document.body.classList.contains('nav-open')
        || document.body.classList.contains('menu-open');

      if (mobileNav.matches || menuLocked || y <= 8) {
        showHeader();
      } else if (delta > 6 && y > 48) {
        headerEl.classList.add('is-header-hidden');
      } else if (delta < 0) {
        showHeader();
      }

      lastScrollY = y;
      scrollTick = false;
    };

    document.addEventListener('scroll', () => {
      if (scrollTick) return;
      scrollTick = true;
      window.requestAnimationFrame(syncHeaderVisibility);
    }, { passive: true, capture: true });

    window.addEventListener('wheel', (event) => {
      if (event.deltaY < -8) showHeader();
    }, { passive: true });

    let lastTouchY = null;
    window.addEventListener('touchstart', (event) => {
      lastTouchY = event.touches[0] ? event.touches[0].clientY : null;
    }, { passive: true });
    window.addEventListener('touchmove', (event) => {
      const y = event.touches[0] ? event.touches[0].clientY : null;
      if (y != null && lastTouchY != null && y > lastTouchY + 2) showHeader();
      lastTouchY = y;
    }, { passive: true });

    headerEl.addEventListener('focusin', showHeader);
    window.addEventListener('resize', measureHeader);
    window.addEventListener('resize', syncHeaderVisibility);
  }

  window.addEventListener('resize', () => {
    const openItem = root.querySelector('.nav-item.open');
    if (openItem) positionMenu(openItem);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.contains(root)) location.reload();
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPhylumMegaNav);
  } else {
    initPhylumMegaNav();
  }
})();
